import {
    filterByTopics,
    filterBySentiments,
    filterByTags,
    hasActiveFilters,
} from './filterStatements'

export default function applyStatementHighlight(
    highlightFilters,
    statements,
    pinnedNodes,
    selectedContextId = null
) {
    if (!statements || statements.length === 0) return statements

    const statementsByTopics = filterByTopics(statements, highlightFilters)
    const statementsBySentiments = filterBySentiments(
        statements,
        highlightFilters
    )
    const statementsByTags = filterByTags(statements, highlightFilters)

    const highlightedStatements = [
        statementsByTopics,
        statementsBySentiments,
        statementsByTags,
    ].filter(arr => arr.length > 0)

    const intersectedStatements = intersectArrays(highlightedStatements)
    const statementsWithHighlights = addHighlightProperty(
        statements,
        intersectedStatements.map(statement => statement.uid),
        highlightFilters
    )

    const statementsWithContext = applyContextHighlight(
        statementsWithHighlights,
        selectedContextId
    )

    const displayedStatements = applyPinnedNodesHighlight(
        statementsWithContext,
        pinnedNodes
    )

    return displayedStatements
}

function intersectArrays(arrays) {
    if (arrays.length === 0) return []
    // Start with the first array, then filter down
    return arrays.reduce((acc, curr) => acc.filter(x => curr.includes(x)))
}

const applyContextHighlight = (statements, selectedContextId) => {
    if (selectedContextId == null) return statements

    return statements.map(statement => ({
        ...statement,
        grayedOut: statement.grayedOut
            ? true
            : statement.context !== selectedContextId,
    }))
}

const applyPinnedNodesHighlight = (statements, pinnedNodes) => {
    // Filter out context node names — they're handled by applyContextHighlight
    const conceptPinnedNodes = pinnedNodes.filter(
        n => !n.startsWith('context:')
    )

    if (conceptPinnedNodes.length === 0) {
        return statements.map(statement => ({
            ...statement,
            grayedOut: statement.grayedOut,
            pinnedRanking: { count: 0, concentration: 0 },
        }))
    }

    return statements.map(statement => {
        const statementHashtags =
            statementsFactory.statementsToHashtags[statement.uid] ||
            statement.hashtags ||
            []

        const count = conceptPinnedNodes.reduce(
            (n, pinnedNode) =>
                statementHashtags.includes(pinnedNode) ? n + 1 : n,
            0
        )
        // Density of pinned concepts within the statement's vocabulary.
        // Short, focused statements rank above long sprawling ones.
        const concentration =
            statementHashtags.length > 0 ? count / statementHashtags.length : 0

        // OR semantics: gray only when no pinned concept matches.
        // Existing grayedOut (from applyContextHighlight or other highlight
        // filters) takes precedence — pinning never un-grays.
        const grayedOut = statement.grayedOut
            ? statement.grayedOut
            : count === 0

        return {
            ...statement,
            grayedOut,
            pinnedRanking: { count, concentration },
        }
    })
}
const addHighlightProperty = (
    statements,
    highlightedStatements,
    highlightFilters
) => {
    const anyFilterActive = hasActiveFilters(highlightFilters)
    return statements.map(statement => {
        if (!anyFilterActive) {
            return {
                ...statement,
                grayedOut: false,
            }
        }
        const statementBelongsToHighlighted = highlightedStatements.includes(
            statement.uid
        )
        const grayedOut = !statementBelongsToHighlighted

        return {
            ...statement,
            grayedOut,
        }
    })
}
